import { EMerchantPixelsAndKeys } from '@olo-web/types/enums/merchantPixelsAndKeys.enum';

const PIXEL_ID_PATTERNS: Record<EMerchantPixelsAndKeys, RegExp> = {
  [EMerchantPixelsAndKeys.GOOGLE_TAG_MANAGER]: /^GTM-[A-Z0-9]+$/,
  [EMerchantPixelsAndKeys.FACEBOOK_PIXEL]: /^\d{5,20}$/,
  [EMerchantPixelsAndKeys.GOOGLE_ADWORDS_KEY]: /^(AW|G|UA|DC)-[A-Za-z0-9-]+$/,
  [EMerchantPixelsAndKeys.GOOGLE_ADWORDS_CONVERSION_LABEL]: /^[A-Za-z0-9_-]+$/,
};

/**
 * Checks a merchant-supplied pixel/analytics id against a strict per-type allowlist
 * before it is interpolated into a third-party script or script attribute.
 *
 * Merchant theme values are stored, untrusted input; this guards the render sites in
 * `Scripts.tsx` that build `dangerouslySetInnerHTML` script bodies from them.
 */
export const isValidMerchantPixelId = (
  pixelType: EMerchantPixelsAndKeys,
  value: string | null | undefined
): boolean => {
  if (!value) return false;
  return PIXEL_ID_PATTERNS[pixelType].test(value);
};
